import { Phone, MoreVertical, Eye, Pin } from "lucide-react";
import AnalysisTags from "../../analysis/AnalysisTags";
import BotControl from "../BotControl";

const ChatHeader = ({
  selectedChat,
  pinnedIds,
  togglePinConversation,
  markAsRead,
  setShowContactInfo,
}) => {
  return (
    <div className="flex items-center justify-between border-b border-gray-200 p-4 dark:border-gray-700">
      <div className="flex items-center space-x-3">
        <div className="flex h-10 w-10 items-center justify-center overflow-hidden rounded-full bg-green-500 text-white">
          <img
            src={selectedChat.contact.profilePic || "/default-avatar.png"}
            loading="lazy"
            onError={(e) => {
              e.currentTarget.onerror = null;
              e.currentTarget.src = "/default-avatar.png";
            }}
            alt="Avatar"
          />
        </div>

        <div className="min-w-0">
          <h3 className="font-semibold text-gray-900 dark:text-gray-100">
            {selectedChat.contact.name}
          </h3>

          <div className="flex items-center space-x-2 text-xs text-gray-500 dark:text-gray-400">
            <Phone className="h-3 w-3" />
            <span>{selectedChat.contact.phoneNumber.replace(/\D/g, "")}</span>
          </div>

          <AnalysisTags
            analysis={selectedChat.analyses?.[0]}
            onClick={() => setShowContactInfo(true)}
          />
        </div>
      </div>

      <div className="flex items-center space-x-2">
        <BotControl conversationId={selectedChat.id} />

        <button
          onClick={() => togglePinConversation(selectedChat.id)}
          className={`rounded-lg px-4 py-2 text-white transition-colors ${
            pinnedIds.includes(selectedChat.id)
              ? "bg-yellow-500 hover:bg-yellow-600"
              : "bg-green-500 hover:bg-green-600"
          }`}
        >
          <Pin className="mr-2 inline h-4 w-4" />
          {pinnedIds.includes(selectedChat.id) ? "Desafixar" : "Fixar Conversa"}
        </button>

        {selectedChat._count.messages > 0 && (
          <button
            onClick={markAsRead}
            className="rounded-lg bg-green-500 px-4 py-2 text-white transition-colors hover:bg-green-600"
          >
            <Eye className="mr-2 inline h-4 w-4" />
            Marcar como lido
          </button>
        )}
        <button
          onClick={() => setShowContactInfo((prev) => !prev)}
          className="rounded-lg p-2 text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-700"
        >
          <MoreVertical className="h-5 w-5" />
        </button>
      </div>
    </div>
  );
};

export default ChatHeader;
